import { localeToISO639Code } from "lib/i18n/localeToISO639Code";
import { HealthProblems } from "lib/questionnaire/question-flows/onboarding/questions/healthProblems";
import { Trans as TransQuestions } from "lib/questionnaire/question-flows/onboarding/questions/trans";
import { useLocale } from "render/context/InternationalizationContext";
import { TextInput } from "render/ui/presentation/Questionnaire/components/TextInput";
import { QuestionView } from "../../components/QuestionView";
import { Step, StepProps } from "../../step";
import { Trans } from "../../trans";

function HealthProblemsStep({
  answers,
  onAnswer,
  onNext,
  onPrev,
  currentQuestion,
  totalQuestions,
  onResetAnswer,
}: StepProps) {
  const answer = answers.get(HealthProblems);
  const label = TransQuestions.HealthProblems.Question();
  const { englishLabel } = TransQuestions.HealthProblems.Question;
  const locale = useLocale();
  const languageCode = localeToISO639Code(locale);

  return (
    <QuestionView
      currentQuestion={currentQuestion}
      totalQuestionCount={totalQuestions}
      question={HealthProblems}
      onNext={onNext}
      onPrev={() => {
        onPrev();
        onResetAnswer(HealthProblems);
      }}
      cta={<Trans.General.Continue />}
      explanation={{
        openText: <Trans.General.WhyAreWeAsking />,
        closeText: <Trans.General.OkIUnderstand />,
        explanationText: <Trans.Steps.PersonalConditionExplanation />,
      }}
    >
      <TextInput
        placeholder={Trans.General.WriteYourAnswer()}
        answer={answer}
        onAnswer={(answer) => {
          onAnswer(HealthProblems, {
            answer,
            questionAnswer: {
              questionId: "healthProblems",
              englishLabel,
              label,
              languageCode,
              answer: {
                $type: "text",
                value: HealthProblems.getValue(answer).trim(),
              },
            },
          });
        }}
      />
    </QuestionView>
  );
}

export function filter(steps: Step[]) {
  steps.push(HealthProblemsStep);
}
